import styled from 'styled-components'
import { myPalette, cardHoverAnimation } from '~/shared/ui/theme'

export const Block = styled.div`
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  display: flex;
  background: ${myPalette.white.main};
  font-size: 18px;
  border-radius: 12px;
  height: 100%;
  cursor: pointer;
  width: 40%;
  ${cardHoverAnimation}
`

export const BlockTitle = styled.div`
  font-size: 14px;
  color: ${myPalette.mutedText.main};
`

export const BlockDescription = styled.div`
  font-size: 18px;
  font-weight: 500;
`
